import axios from "axios";
import initializeAxios from "../util/Axios";

class ContentServices {
  constructor() {
    initializeAxios();
  }

  async getBlogs({ searchTerm, isActive, pageIndex, pageSize }) {
    const response = await axios.get("/api/blogs", {
      params: {
        searchTerm,
        isActive,
        pageIndex,
        pageSize
      }
    });
    console.log(response.data);
    return response.data;
  }

  async addBlog({
    slug,
    blogStatus,
    title,
    keywords,
    description,
    shortDescription,
    content,
    blogTitle,
    isFeatured,
    image,
    alt,
    caption
  }) {
    const response = await axios.post("/api/blog/add", {
      slug,
      blogStatus,
      title,
      keywords,
      description,
      shortDescription,
      content,
      blogTitle,
      isFeatured,
      image,
      alt,
      caption
    });
console.log(response);
    return response;
  }

  async editBlog({
    blogId,
    slug,
    blogStatus,
    title,
    keywords,
    description,
    shortDescription,
    content,
    blogTitle,
    isFeatured,
    image,
    alt,
    caption
  }) {
    const response = await axios.put("/api/blog/update", {
      blogId,
      slug,
      blogStatus,
      title,
      keywords,
      description,
      shortDescription,
      content,
      blogTitle,
      isFeatured,
      image,
      alt,
      caption
    });

    return response;
  }

  async deleteBlog(blogId, isActive) {
    const response = await axios.put("/api/blog/delete", {
      blogId,
      isActive
    });

    return response.data;
  }

  
  async getBlogDetails(id) {
    const response = await axios.get("/api/blog/details", {
      params: {
        blogId: id
      }
    });

    return response;
  }


  async uploadToS3(data) {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post("/api/util/uploadimage", formData);
    return response.data;
  }

}

export default new ContentServices();
